// extracted by mini-css-extract-plugin
export default {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","container":"checkboxes_container__eeioc","disabled":"checkboxes_disabled__GNNiR","box":"checkboxes_box__34Cpb"};